import React, { useEffect } from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import { toast } from "react-toastify";
import Popup from "components/popup";
import { withRouter } from "react-router-dom";

// Actions
// import { deleteCohort } from "repository/actions/data/dashboard/cohorts";

export default withSnackbar(
  withRouter(function (props) {

    const { isOpen, setClose, itemId, user, cohorts, setCohorts, getCohorts, deleteCohort, setRefreshAlgolia } =
      props;
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteItem = () => {

      if (user && user != null) {
        setSaveLoading(true);

        deleteCohort( itemId, user.idToken)
          .then((result) => {
            setTimeout(()=>{setRefreshAlgolia(true)},2000)
            setTimeout(()=>{setRefreshAlgolia(false)},2000)
            setClose();
            setSaveLoading(false);
            toast.success(`Cohort successfully deleted`);
            

          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete selected cohort"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteItem()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete this cohort?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
